import { render, staticRenderFns } from "./data_merged.vue?vue&type=template&id=41565f3f&scoped=true"
import script from "./data_merged.vue?vue&type=script&lang=js"
export * from "./data_merged.vue?vue&type=script&lang=js"
import style0 from "./data_merged.vue?vue&type=style&index=0&id=41565f3f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41565f3f",
  null
  
)

export default component.exports